import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../../axiosConfig';

const fetchMpCategory = async ({ mpCategoryId, store }) => {
  const params = new URLSearchParams({ mp_field_is_selected: 'true' });
  // When a store is provided, the backend resolves attribute list values for
  // that store/locale and category (e.g. Amazon unit_count, localized enums).
  if (store) params.set('store', store);
  const response = await axiosInstance.get(
    `/mp_categories/${mpCategoryId}/?${params.toString()}`
  );
  return response.data;
};

export const useGetMpCategorieAttributes = ({
  mpCategoryId,
  store,
  options = {},
}) => {
  const { data, error, isLoading, isError, refetch, isFetching } = useQuery({
    queryKey: ['mp-category-attributes', mpCategoryId, store],
    queryFn: () => fetchMpCategory({ mpCategoryId, store }),
    enabled: (options.enabled ?? true) && !!mpCategoryId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    retry: 2,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    refetchOnWindowFocus: false,
  });

  const categorieAttributes = data?.attributes;

  return {
    categorieAttributes,
    error,
    isLoading,
    isError,
    isFetching,
    refetch,
  };
};
